export default __webpack_public_path__ + "static/favicon-f446c9662e13b0a293d2482fbb42981d.ico";